// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gx7R","left":"styles_left__HB15p"};